import { render, staticRenderFns } from "./NewProductView.vue?vue&type=template&id=6745acda&scoped=true&"
import script from "./NewProductView.vue?vue&type=script&lang=js&"
export * from "./NewProductView.vue?vue&type=script&lang=js&"
import style0 from "./NewProductView.vue?vue&type=style&index=0&id=6745acda&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6745acda",
  null
  
)

export default component.exports